import React from 'react';
const IconActionCamera = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M9 2L7.17 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4H16.83L15 2H9ZM12.0001 15C13.6569 15 15.0001 13.6569 15.0001 12C15.0001 10.3431 13.6569 9 12.0001 9C10.3432 9 9.00009 10.3431 9.00009 12C9.00009 13.6569 10.3432 15 12.0001 15ZM6.99991 12C6.99991 14.76 9.23991 17 11.9999 17C14.7599 17 16.9999 14.76 16.9999 12C16.9999 9.24 14.7599 7 11.9999 7C9.23991 7 6.99991 9.24 6.99991 12Z" fill="#666666"/>
</svg>
);
};
export default IconActionCamera;